import React from 'react';
import { useNavigate } from 'react-router-dom';
import { authService } from '../../services/auth.service';
import { FaBell, FaUser, FaSignOutAlt } from 'react-icons/fa';

const Navbar = () => {
  const navigate = useNavigate();
  const user = authService.getCurrentUser();

  const handleLogout = () => {
    authService.logout();
    navigate('/login');
  };

  return (
    <nav className="bg-white shadow-md px-6 py-4 flex items-center justify-between">
      <div className="flex-1">
        <h2 className="text-xl font-semibold text-gray-800">Dashboard</h2>
      </div>

      <div className="flex items-center space-x-4">
        <button className="p-2 hover:bg-gray-100 rounded-full relative">
          <FaBell className="text-gray-600 text-xl" />
          <span className="absolute top-0 right-0 bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
            3
          </span>
        </button>

        <div className="flex items-center space-x-2">
          <div className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center">
            <FaUser className="text-white" />
          </div>
          <span className="text-gray-700 font-medium">{user?.name}</span>
        </div>

        <button
          onClick={handleLogout}
          className="p-2 hover:bg-gray-100 rounded-full"
        >
          <FaSignOutAlt className="text-gray-600 text-xl" />
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
